import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as FileIcon } from 'icons/file-icon.svg';
import { ReactComponent as PreviewIcon } from 'icons/preview-icon.svg';
import { useAppContext } from 'components/Context/AppContext';
import Button from '../Button';
import Thumbnail from '../UploadImageCustomOrder/Thumbnail';
import { getConfig } from 'config/runtime';

// limit size of image file in byte
const limitSize = 1048576;

const UploadImageWithdraw = ({ imageFile, handleRemove, handleUpload, htmlFor, handleImageChange, handlePreview }) => {
  // context
  const { showToast, setShowConfirmation } = useAppContext();

  const targetRef = useRef(null);
  const [image, setImage] = useState(null);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  // drag active state
  const [dragActive, setDragActive] = React.useState(false);

  // will set image list if Image files not empty
  useEffect(() => {
    if (!isFirstLoad) return;

    if (!imageFile) return setImage(null);

    const data = {
      id: Math.random() + 1 + '',
      url: imageFile ? getConfig('REACT_APP_IMAGES') + imageFile : '',
      show: false,
    };

    setImage(data);
  }, [imageFile]);

  // function to loop through Files and upload
  const uploadImages = async (file, limitSize) => {
    if (file.size >= limitSize) {
      showToast({ type: 'error', message: 'Ukuran File Terlalu Besar' });
      return;
    }

    const newObjImages = {
      url: URL.createObjectURL(file),
      name: file.name.split(' ').length > 1 ? file.name.split(' ').join('-') : file.name,
      id: Math.random() + 1 + '', // id sementara
      show: false,
    };

    setImage(newObjImages);

    handleImageChange(file, htmlFor, newObjImages);
  };

  // handle drag events
  const handleDrag = function (e) {
    setIsFirstLoad(false);
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  // add iamge to imagelist when file is dropped
  const handleDrop = function (e) {
    setIsFirstLoad(false);
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files?.[0]) {
      const newImages = e.dataTransfer.files[0];
      // check if there are files
      if (newImages) {
        uploadImages(newImages, limitSize);
      }
    }
  };

  // add image to imagelist when file is selected with click
  const onImageChange = (e) => {
    setIsFirstLoad(false);
    e.preventDefault();
    e.stopPropagation();
    const newImages = e.target.files[0];
    // check if there are files
    if (newImages) {
      uploadImages(newImages, limitSize);
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
    handleRemove?.();
  };

  const handleUploadImage = () => {
    setShowConfirmation({
      message: 'Apakah Anda ingin mengupload foto ini?',
      show: true,
      onClick: () => handleUpload?.(),
    });
  };

  return (
    <div
      className="upload-image-withdraw__container"
      style={{ height: image ? 'fit-content' : '100%' }}
      onDragEnter={handleDrag}
    >
      <input
        type="file"
        name="upload-image-withdraw"
        id={htmlFor || 'upload-image-withdraw'}
        accept="image/*"
        hidden
        ref={targetRef}
        onChange={onImageChange}
      />
      {image ? (
        <>
          <div
            className={
              dragActive
                ? 'upload-image-withdraw__container__thumbnails active'
                : 'upload-image-withdraw__container__thumbnails'
            }
          >
            <Thumbnail image={image.url} id={image.id} onClick={() => targetRef.current.click()} />
            <Button className="button__preview" bgColor="#000000D4" onClick={() => handlePreview(image.url)}>
              <PreviewIcon />
              Preview
            </Button>
          </div>
          <div className="upload-image-withdraw__buttons">
            <Button variant="danger" onClick={handleRemoveImage}>
              Hapus
            </Button>
            <Button variant="success" onClick={handleUploadImage}>
              Upload
            </Button>
          </div>
        </>
      ) : (
        <label className="button" htmlFor={htmlFor || 'upload-image-withdraw'}>
          <div className={dragActive ? 'button__field active' : 'button__field'} style={{ justifyContent: 'center' }}>
            <FileIcon />
            <p>
              Drop your image here, or{' '}
              <button type="button" onClick={() => targetRef.current.click()}>
                browse
              </button>
            </p>
          </div>
        </label>
      )}
      {dragActive && (
        <div
          className="drag-file-element"
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        />
      )}
    </div>
  );
};

export default React.memo(UploadImageWithdraw);
